// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CareCloudIntegrationAppointmentNoteRequest,
    CareCloudIntegrationCreateRequest,
    CareCloudIntegrationResponse,
    CareCloudIntegrationUpdateRequest,
    CentralReachIntegrationCreateRequest,
    CentralReachIntegrationResponse,
    CentralReachIntegrationUpdateRequest,
    ObjectNoResponse,
    ProviderCreateIntegrationApiPayload,
    ProviderCreateIntegrationElationPayload,
    ProviderCreateIntegrationExportSftpPayload,
    ProviderCreateIntegrationHl7Payload,
    ProviderCreateIntegrationImportSftpPayload,
    ProviderCreateIntegrationSftpPayload,
    ProviderIntegrationApi,
    ProviderIntegrationElation,
    ProviderIntegrationExportSftp,
    ProviderIntegrationHealthie,
    ProviderIntegrationHealthiePayload,
    ProviderIntegrationHl7,
    ProviderIntegrationImportSftp,
    ProviderIntegrationSftp,
    ProviderIntegrationSortType,
    ProviderIntegrationSso,
    ProviderIntegrationTerminal,
    ProviderIntegrationTerminalToken,
    ProviderIntegrationWebhooks,
    SupportCreateIntegrationApiPayload,
    SupportCreateIntegrationCanvasPayload,
    SupportCreateIntegrationCharmPayload,
    SupportCreateIntegrationElationPayload,
    SupportCreateIntegrationEnterWorkflowsPayload,
    SupportCreateIntegrationExportSftpPayload,
    SupportCreateIntegrationHl7Payload,
    SupportCreateIntegrationImportSftpPayload,
    SupportCreateIntegrationSftpPayload,
    SupportIngestModMedPayload,
    SupportIntegrationApi,
    SupportIntegrationCanvas,
    SupportIntegrationCharm,
    SupportIntegrationElation,
    SupportIntegrationEnterWorkflows,
    SupportIntegrationExportSftp,
    SupportIntegrationHealthie,
    SupportIntegrationHealthiePayload,
    SupportIntegrationHl7,
    SupportIntegrationImportSftp,
    SupportIntegrationModMedIngestion,
    SupportIntegrationNetHealth,
    SupportIntegrationNetHealthPayload,
    SupportIntegrationRoyal,
    SupportIntegrationRoyalCollectionPatientRefundPayload,
    SupportIntegrationRoyalCollectionRefundResponse,
    SupportIntegrationRoyalPayload,
    SupportIntegrationSftp,
    SupportIntegrationSortType,
    SupportIntegrationSso,
    SupportIntegrationWebhooks,
    SupportInvalidateElationBillPayload,
    SupportUnlockHealthieFormAnswerGroupPayload,
    TebraIntegrationCreateRequest,
    TebraIntegrationResponse,
    TebraIntegrationUpdateRequest,
    TemporaryDocumentUrl,
    CareCloudIntegrationAppointmentNoteRequestToJSON,
    CareCloudIntegrationCreateRequestToJSON,
    CareCloudIntegrationUpdateRequestToJSON,
    CentralReachIntegrationCreateRequestToJSON,
    CentralReachIntegrationUpdateRequestToJSON,
    ProviderCreateIntegrationApiPayloadToJSON,
    ProviderCreateIntegrationElationPayloadToJSON,
    ProviderCreateIntegrationExportSftpPayloadToJSON,
    ProviderCreateIntegrationHl7PayloadToJSON,
    ProviderCreateIntegrationImportSftpPayloadToJSON,
    ProviderCreateIntegrationSftpPayloadToJSON,
    ProviderIntegrationHealthiePayloadToJSON,
    SupportCreateIntegrationApiPayloadToJSON,
    SupportCreateIntegrationCanvasPayloadToJSON,
    SupportCreateIntegrationCharmPayloadToJSON,
    SupportCreateIntegrationElationPayloadToJSON,
    SupportCreateIntegrationEnterWorkflowsPayloadToJSON,
    SupportCreateIntegrationExportSftpPayloadToJSON,
    SupportCreateIntegrationHl7PayloadToJSON,
    SupportCreateIntegrationImportSftpPayloadToJSON,
    SupportCreateIntegrationSftpPayloadToJSON,
    SupportIngestModMedPayloadToJSON,
    SupportIntegrationHealthiePayloadToJSON,
    SupportIntegrationNetHealthPayloadToJSON,
    SupportIntegrationRoyalCollectionPatientRefundPayloadToJSON,
    SupportIntegrationRoyalPayloadToJSON,
    SupportInvalidateElationBillPayloadToJSON,
    SupportUnlockHealthieFormAnswerGroupPayloadToJSON,
    TebraIntegrationCreateRequestToJSON,
    TebraIntegrationUpdateRequestToJSON,
    CareCloudIntegrationResponseFromJSON,
    CentralReachIntegrationResponseFromJSON,
    ObjectNoResponseFromJSON,
    ProviderIntegrationApiFromJSON,
    ProviderIntegrationElationFromJSON,
    ProviderIntegrationExportSftpFromJSON,
    ProviderIntegrationHealthieFromJSON,
    ProviderIntegrationHl7FromJSON,
    ProviderIntegrationImportSftpFromJSON,
    ProviderIntegrationSftpFromJSON,
    ProviderIntegrationSsoFromJSON,
    ProviderIntegrationTerminalFromJSON,
    ProviderIntegrationTerminalTokenFromJSON,
    ProviderIntegrationWebhooksFromJSON,
    SupportIntegrationApiFromJSON,
    SupportIntegrationCanvasFromJSON,
    SupportIntegrationCharmFromJSON,
    SupportIntegrationElationFromJSON,
    SupportIntegrationEnterWorkflowsFromJSON,
    SupportIntegrationExportSftpFromJSON,
    SupportIntegrationHealthieFromJSON,
    SupportIntegrationHl7FromJSON,
    SupportIntegrationImportSftpFromJSON,
    SupportIntegrationModMedIngestionFromJSON,
    SupportIntegrationNetHealthFromJSON,
    SupportIntegrationRoyalFromJSON,
    SupportIntegrationRoyalCollectionRefundResponseFromJSON,
    SupportIntegrationSftpFromJSON,
    SupportIntegrationSsoFromJSON,
    SupportIntegrationWebhooksFromJSON,
    TebraIntegrationResponseFromJSON,
    TemporaryDocumentUrlFromJSON,
} from '../models';

export interface CreateCareCloudAppointmentCollectionIncidentNoteRequest {
    id: string;
    careCloudIntegrationAppointmentNoteRequest: CareCloudIntegrationAppointmentNoteRequest;
}

export interface CreateCareCloudIntegrationForBankUserRequest {
    careCloudIntegrationCreateRequest: CareCloudIntegrationCreateRequest;
}

export interface CreateCentralReachIntegrationForBankUserRequest {
    centralReachIntegrationCreateRequest: CentralReachIntegrationCreateRequest;
}

export interface CreateTebraIntegrationForBankUserRequest {
    tebraIntegrationCreateRequest: TebraIntegrationCreateRequest;
}

export interface DisableCareCloudIntegrationForBankUserRequest {
    id: string;
}

export interface DisableCentralReachIntegrationForBankUserRequest {
    id: string;
}

export interface DisableProviderApiIntegrationRequest {
    id: string;
}

export interface DisableProviderHl7IntegrationRequest {
    id: string;
}

export interface DisableProviderSftpIntegrationRequest {
    id: string;
}

export interface DisableProviderSftpIntegrationExportRequest {
    id: string;
}

export interface DisableProviderSftpIntegrationImportRequest {
    id: string;
}

export interface DisableProviderTerminalIntegrationRequest {
    id: string;
}

export interface DisableSupportApiIntegrationRequest {
    id: string;
}

export interface DisableSupportHl7IntegrationRequest {
    id: string;
}

export interface DisableSupportSftpIntegrationRequest {
    id: string;
}

export interface DisableSupportSftpIntegrationExportRequest {
    id: string;
}

export interface DisableSupportSftpIntegrationImportRequest {
    id: string;
}

export interface DisableTebraIntegrationForBankUserRequest {
    id: string;
}

export interface EnableCareCloudIntegrationForBankUserRequest {
    id: string;
}

export interface EnableCentralReachIntegrationForBankUserRequest {
    id: string;
}

export interface EnableTebraIntegrationForBankUserRequest {
    id: string;
}

export interface GetProviderApiIntegrationRequest {
    id: string;
}

export interface GetProviderHl7IntegrationRequest {
    id: string;
}

export interface GetProviderSftpIntegrationRequest {
    id: string;
}

export interface GetProviderSftpIntegrationExportRequest {
    id: string;
}

export interface GetProviderSftpIntegrationImportRequest {
    id: string;
}

export interface GetProviderTerminalIntegrationRequest {
    id: string;
}

export interface GetSupportApiIntegrationRequest {
    id: string;
}

export interface GetSupportHl7IntegrationRequest {
    id: string;
}

export interface GetSupportIntegrationRoyalDocumentInsuranceCardRequest {
    id: string;
}

export interface GetSupportIntegrationRoyalDocumentReportRequest {
    id: string;
}

export interface GetSupportSftpIntegrationRequest {
    id: string;
}

export interface GetSupportSftpIntegrationExportRequest {
    id: string;
}

export interface GetSupportSftpIntegrationImportRequest {
    id: string;
}

export interface InboundSupportExperityAdtRequest {
    body: string;
}

export interface IngestSupportIntegrationModMedRequest {
    supportIngestModMedPayload: SupportIngestModMedPayload;
}

export interface InvalidateSupportIntegrationElationBillRequest {
    id: string;
    supportInvalidateElationBillPayload: SupportInvalidateElationBillPayload;
}

export interface ListProviderApiIntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderApiIntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderApplicationSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderApplicationSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderHl7IntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderHl7IntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderIntegrationExportSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderIntegrationExportSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderIntegrationImportSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderIntegrationImportSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderTerminalIntegrationTokensRequest {
    id: string;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderTerminalIntegrationTokensOrderEnum>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderTerminalIntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderTerminalIntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListSupportApiIntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportApiIntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    sort?: Array<SupportIntegrationSortType>;
}

export interface ListSupportApplicationSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportApplicationSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<SupportIntegrationSortType>;
}

export interface ListSupportHl7IntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportHl7IntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    sort?: Array<SupportIntegrationSortType>;
}

export interface ListSupportIntegrationExportSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportIntegrationExportSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<SupportIntegrationSortType>;
}

export interface ListSupportIntegrationImportSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportIntegrationImportSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<SupportIntegrationSortType>;
}

export interface PostProviderIntegrationApiRequest {
    providerCreateIntegrationApiPayload: ProviderCreateIntegrationApiPayload;
}

export interface PostProviderIntegrationElationRequest {
    providerCreateIntegrationElationPayload: ProviderCreateIntegrationElationPayload;
}

export interface PostProviderIntegrationExportSftpRequest {
    providerCreateIntegrationExportSftpPayload: ProviderCreateIntegrationExportSftpPayload;
}

export interface PostProviderIntegrationHealthieRequest {
    providerIntegrationHealthiePayload: ProviderIntegrationHealthiePayload;
}

export interface PostProviderIntegrationHl7Request {
    providerCreateIntegrationHl7Payload: ProviderCreateIntegrationHl7Payload;
}

export interface PostProviderIntegrationImportSftpRequest {
    providerCreateIntegrationImportSftpPayload: ProviderCreateIntegrationImportSftpPayload;
}

export interface PostProviderIntegrationSftpRequest {
    providerCreateIntegrationSftpPayload: ProviderCreateIntegrationSftpPayload;
}

export interface PostSupportIntegrationApiRequest {
    supportCreateIntegrationApiPayload: SupportCreateIntegrationApiPayload;
}

export interface PostSupportIntegrationCanvasRequest {
    supportCreateIntegrationCanvasPayload: SupportCreateIntegrationCanvasPayload;
}

export interface PostSupportIntegrationCharmRequest {
    supportCreateIntegrationCharmPayload: SupportCreateIntegrationCharmPayload;
}

export interface PostSupportIntegrationElationRequest {
    supportCreateIntegrationElationPayload: SupportCreateIntegrationElationPayload;
}

export interface PostSupportIntegrationEnterWorkflowsRequest {
    supportCreateIntegrationEnterWorkflowsPayload: SupportCreateIntegrationEnterWorkflowsPayload;
}

export interface PostSupportIntegrationExportSftpRequest {
    supportCreateIntegrationExportSftpPayload: SupportCreateIntegrationExportSftpPayload;
}

export interface PostSupportIntegrationHealthieRequest {
    supportIntegrationHealthiePayload: SupportIntegrationHealthiePayload;
}

export interface PostSupportIntegrationHl7Request {
    supportCreateIntegrationHl7Payload: SupportCreateIntegrationHl7Payload;
}

export interface PostSupportIntegrationImportSftpRequest {
    supportCreateIntegrationImportSftpPayload: SupportCreateIntegrationImportSftpPayload;
}

export interface PostSupportIntegrationNethealthRequest {
    supportIntegrationNetHealthPayload: SupportIntegrationNetHealthPayload;
}

export interface PostSupportIntegrationRoyalRequest {
    supportIntegrationRoyalPayload: SupportIntegrationRoyalPayload;
}

export interface PostSupportIntegrationSftpRequest {
    supportCreateIntegrationSftpPayload: SupportCreateIntegrationSftpPayload;
}

export interface PostSupportRoyalCollectionPatientRefundRequest {
    supportIntegrationRoyalCollectionPatientRefundPayload: SupportIntegrationRoyalCollectionPatientRefundPayload;
}

export interface ProviderCreateCareCloudIntegrationForBankUserRequest {
    careCloudIntegrationCreateRequest: CareCloudIntegrationCreateRequest;
}

export interface ProviderCreateCentralReachIntegrationForBankUserRequest {
    centralReachIntegrationCreateRequest: CentralReachIntegrationCreateRequest;
}

export interface ProviderCreateTebraIntegrationForBankUserRequest {
    tebraIntegrationCreateRequest: TebraIntegrationCreateRequest;
}

export interface ProviderDisableCareCloudIntegrationForBankUserRequest {
    id: string;
}

export interface ProviderDisableCentralReachIntegrationForBankUserRequest {
    id: string;
}

export interface ProviderDisableTebraIntegrationForBankUserRequest {
    id: string;
}

export interface ProviderEnableCareCloudIntegrationForBankUserRequest {
    id: string;
}

export interface ProviderEnableCentralReachIntegrationForBankUserRequest {
    id: string;
}

export interface ProviderEnableTebraIntegrationForBankUserRequest {
    id: string;
}

export interface ProviderUpdateCareCloudIntegrationForBankUserRequest {
    id: string;
    careCloudIntegrationUpdateRequest: CareCloudIntegrationUpdateRequest;
}

export interface ProviderUpdateCentralReachIntegrationForBankUserRequest {
    id: string;
    centralReachIntegrationUpdateRequest: CentralReachIntegrationUpdateRequest;
}

export interface ProviderUpdateTebraIntegrationForBankUserRequest {
    id: string;
    tebraIntegrationUpdateRequest: TebraIntegrationUpdateRequest;
}

export interface ResetCentralReachEncounterByControlNumberRequest {
    id: string;
    cid: string;
}

export interface RunSupportSftpIntegrationRequest {
    id: string;
}

export interface UnlockSupportIntegrationHealthieFormAnswerGroupRequest {
    id: string;
    supportUnlockHealthieFormAnswerGroupPayload: SupportUnlockHealthieFormAnswerGroupPayload;
}

export interface UpdateCareCloudIntegrationForBankUserRequest {
    id: string;
    careCloudIntegrationUpdateRequest: CareCloudIntegrationUpdateRequest;
}

export interface UpdateCentralReachIntegrationForBankUserRequest {
    id: string;
    centralReachIntegrationUpdateRequest: CentralReachIntegrationUpdateRequest;
}

export interface UpdateProviderIntegrationHealthieRequest {
    providerIntegrationHealthiePayload: ProviderIntegrationHealthiePayload;
}

export interface UpdateSupportIntegrationHealthieRequest {
    supportIntegrationHealthiePayload: SupportIntegrationHealthiePayload;
}

export interface UpdateSupportIntegrationNethealthRequest {
    supportIntegrationNetHealthPayload: SupportIntegrationNetHealthPayload;
}

export interface UpdateSupportIntegrationRoyalRequest {
    supportIntegrationRoyalPayload: SupportIntegrationRoyalPayload;
}

export interface UpdateTebraIntegrationForBankUserRequest {
    id: string;
    tebraIntegrationUpdateRequest: TebraIntegrationUpdateRequest;
}

/**
 * no description
 */
export class IntegrationApi extends runtime.BaseAPI {

    /**
     * Create a CareCloud appointment collection incident note
     * Create a CareCloud appointment collection incident note
     */
    async createCareCloudAppointmentCollectionIncidentNoteRaw(requestParameters: CreateCareCloudAppointmentCollectionIncidentNoteRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createCareCloudAppointmentCollectionIncidentNote.');
        }

        if (requestParameters['careCloudIntegrationAppointmentNoteRequest'] === null || requestParameters['careCloudIntegrationAppointmentNoteRequest'] === undefined) {
            throw new runtime.RequiredError('careCloudIntegrationAppointmentNoteRequest','Required parameter requestParameters.careCloudIntegrationAppointmentNoteRequest was null or undefined when calling createCareCloudAppointmentCollectionIncidentNote.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/carecloud/appointment/{id}/note/collection_incident`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CareCloudIntegrationAppointmentNoteRequestToJSON(requestParameters['careCloudIntegrationAppointmentNoteRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a CareCloud appointment collection incident note
     * Create a CareCloud appointment collection incident note
     */
    async createCareCloudAppointmentCollectionIncidentNote(requestParameters: CreateCareCloudAppointmentCollectionIncidentNoteRequest): Promise<string> {
        const response = await this.createCareCloudAppointmentCollectionIncidentNoteRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a CareCloud integration
     * Create a carecloud integration
     */
    async createCareCloudIntegrationForBankUserRaw(requestParameters: CreateCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['careCloudIntegrationCreateRequest'] === null || requestParameters['careCloudIntegrationCreateRequest'] === undefined) {
            throw new runtime.RequiredError('careCloudIntegrationCreateRequest','Required parameter requestParameters.careCloudIntegrationCreateRequest was null or undefined when calling createCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/carecloud`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CareCloudIntegrationCreateRequestToJSON(requestParameters['careCloudIntegrationCreateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a CareCloud integration
     * Create a carecloud integration
     */
    async createCareCloudIntegrationForBankUser(requestParameters: CreateCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.createCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a CentralReach integration
     * Create a CentralReach integration
     */
    async createCentralReachIntegrationForBankUserRaw(requestParameters: CreateCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['centralReachIntegrationCreateRequest'] === null || requestParameters['centralReachIntegrationCreateRequest'] === undefined) {
            throw new runtime.RequiredError('centralReachIntegrationCreateRequest','Required parameter requestParameters.centralReachIntegrationCreateRequest was null or undefined when calling createCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/centralreach`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CentralReachIntegrationCreateRequestToJSON(requestParameters['centralReachIntegrationCreateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a CentralReach integration
     * Create a CentralReach integration
     */
    async createCentralReachIntegrationForBankUser(requestParameters: CreateCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.createCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Tebra integration
     * Create a tebra integration
     */
    async createTebraIntegrationForBankUserRaw(requestParameters: CreateTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['tebraIntegrationCreateRequest'] === null || requestParameters['tebraIntegrationCreateRequest'] === undefined) {
            throw new runtime.RequiredError('tebraIntegrationCreateRequest','Required parameter requestParameters.tebraIntegrationCreateRequest was null or undefined when calling createTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/tebra`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TebraIntegrationCreateRequestToJSON(requestParameters['tebraIntegrationCreateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a Tebra integration
     * Create a tebra integration
     */
    async createTebraIntegrationForBankUser(requestParameters: CreateTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.createTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a CareCloud integration
     * Disable a carecloud integration
     */
    async disableCareCloudIntegrationForBankUserRaw(requestParameters: DisableCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/carecloud/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Disable a CareCloud integration
     * Disable a carecloud integration
     */
    async disableCareCloudIntegrationForBankUser(requestParameters: DisableCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.disableCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a CentralReach integration
     * Disable a CentralReach integration
     */
    async disableCentralReachIntegrationForBankUserRaw(requestParameters: DisableCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/centralreach/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Disable a CentralReach integration
     * Disable a CentralReach integration
     */
    async disableCentralReachIntegrationForBankUser(requestParameters: DisableCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.disableCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableProviderApiIntegrationRaw(requestParameters: DisableProviderApiIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableProviderApiIntegration(requestParameters: DisableProviderApiIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableProviderHl7IntegrationRaw(requestParameters: DisableProviderHl7IntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableProviderHl7Integration(requestParameters: DisableProviderHl7IntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable the Elation integration
     * Disable the Elation integration
     */
    async disableProviderIntegrationElationRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/elation/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Elation integration
     * Disable the Elation integration
     */
    async disableProviderIntegrationElation(): Promise<ObjectNoResponse> {
        const response = await this.disableProviderIntegrationElationRaw();
        return await response.value();
    }

    /**
     * Disable the Healthie integration
     * Disable the Healthie integration
     */
    async disableProviderIntegrationHealthieRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/healthie/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Healthie integration
     * Disable the Healthie integration
     */
    async disableProviderIntegrationHealthie(): Promise<ObjectNoResponse> {
        const response = await this.disableProviderIntegrationHealthieRaw();
        return await response.value();
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableProviderSftpIntegrationRaw(requestParameters: DisableProviderSftpIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableProviderSftpIntegration(requestParameters: DisableProviderSftpIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration export SFTP server
     * Disable the integration export SFTP server
     */
    async disableProviderSftpIntegrationExportRaw(requestParameters: DisableProviderSftpIntegrationExportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderSftpIntegrationExport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/export/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration export SFTP server
     * Disable the integration export SFTP server
     */
    async disableProviderSftpIntegrationExport(requestParameters: DisableProviderSftpIntegrationExportRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderSftpIntegrationExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableProviderSftpIntegrationImportRaw(requestParameters: DisableProviderSftpIntegrationImportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableProviderSftpIntegrationImport(requestParameters: DisableProviderSftpIntegrationImportRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration terminal
     * Disable the integration terminal
     */
    async disableProviderTerminalIntegrationRaw(requestParameters: DisableProviderTerminalIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderTerminalIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration terminal
     * Disable the integration terminal
     */
    async disableProviderTerminalIntegration(requestParameters: DisableProviderTerminalIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderTerminalIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableSupportApiIntegrationRaw(requestParameters: DisableSupportApiIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableSupportApiIntegration(requestParameters: DisableSupportApiIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableSupportHl7IntegrationRaw(requestParameters: DisableSupportHl7IntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableSupportHl7Integration(requestParameters: DisableSupportHl7IntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable the Canvas integration
     * Disable the Canvas integration
     */
    async disableSupportIntegrationCanvasRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/canvas/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Canvas integration
     * Disable the Canvas integration
     */
    async disableSupportIntegrationCanvas(): Promise<ObjectNoResponse> {
        const response = await this.disableSupportIntegrationCanvasRaw();
        return await response.value();
    }

    /**
     * Disable the Charm integration
     * Disable the Charm integration
     */
    async disableSupportIntegrationCharmRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/charm/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Charm integration
     * Disable the Charm integration
     */
    async disableSupportIntegrationCharm(): Promise<ObjectNoResponse> {
        const response = await this.disableSupportIntegrationCharmRaw();
        return await response.value();
    }

    /**
     * Disable the Elation integration
     * Disable the Elation integration
     */
    async disableSupportIntegrationElationRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/elation/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Elation integration
     * Disable the Elation integration
     */
    async disableSupportIntegrationElation(): Promise<ObjectNoResponse> {
        const response = await this.disableSupportIntegrationElationRaw();
        return await response.value();
    }

    /**
     * Disable the Enter Workflows integration
     * Disable the Enter Workflows integration
     */
    async disableSupportIntegrationEnterWorkflowsRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/workflows/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Enter Workflows integration
     * Disable the Enter Workflows integration
     */
    async disableSupportIntegrationEnterWorkflows(): Promise<ObjectNoResponse> {
        const response = await this.disableSupportIntegrationEnterWorkflowsRaw();
        return await response.value();
    }

    /**
     * Disable the Healthie integration
     * Disable the Healthie integration
     */
    async disableSupportIntegrationHealthieRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/healthie/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Healthie integration
     * Disable the Healthie integration
     */
    async disableSupportIntegrationHealthie(): Promise<ObjectNoResponse> {
        const response = await this.disableSupportIntegrationHealthieRaw();
        return await response.value();
    }

    /**
     * Disable the Nethealth integration
     * Disable the Nethealth integration
     */
    async disableSupportIntegrationNethealthRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/nethealth/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Nethealth integration
     * Disable the Nethealth integration
     */
    async disableSupportIntegrationNethealth(): Promise<ObjectNoResponse> {
        const response = await this.disableSupportIntegrationNethealthRaw();
        return await response.value();
    }

    /**
     * Disable the Royal integration
     * Disable the Royal integration
     */
    async disableSupportIntegrationRoyalRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/royal/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Royal integration
     * Disable the Royal integration
     */
    async disableSupportIntegrationRoyal(): Promise<ObjectNoResponse> {
        const response = await this.disableSupportIntegrationRoyalRaw();
        return await response.value();
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableSupportSftpIntegrationRaw(requestParameters: DisableSupportSftpIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableSupportSftpIntegration(requestParameters: DisableSupportSftpIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration export SFTP server
     * Disable the integration export SFTP server
     */
    async disableSupportSftpIntegrationExportRaw(requestParameters: DisableSupportSftpIntegrationExportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSftpIntegrationExport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/export/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration export SFTP server
     * Disable the integration export SFTP server
     */
    async disableSupportSftpIntegrationExport(requestParameters: DisableSupportSftpIntegrationExportRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSftpIntegrationExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableSupportSftpIntegrationImportRaw(requestParameters: DisableSupportSftpIntegrationImportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableSupportSftpIntegrationImport(requestParameters: DisableSupportSftpIntegrationImportRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a Tebra integration
     * Disable a tebra integration
     */
    async disableTebraIntegrationForBankUserRaw(requestParameters: DisableTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/tebra/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Disable a Tebra integration
     * Disable a tebra integration
     */
    async disableTebraIntegrationForBankUser(requestParameters: DisableTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.disableTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a CareCloud integration
     * Enable a carecloud integration
     */
    async enableCareCloudIntegrationForBankUserRaw(requestParameters: EnableCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/carecloud/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Enable a CareCloud integration
     * Enable a carecloud integration
     */
    async enableCareCloudIntegrationForBankUser(requestParameters: EnableCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.enableCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a CentralReach integration
     * Enable a CentralReach integration
     */
    async enableCentralReachIntegrationForBankUserRaw(requestParameters: EnableCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/centralreach/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Enable a CentralReach integration
     * Enable a CentralReach integration
     */
    async enableCentralReachIntegrationForBankUser(requestParameters: EnableCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.enableCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a Tebra integration
     * Enable a tebra integration
     */
    async enableTebraIntegrationForBankUserRaw(requestParameters: EnableTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/tebra/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Enable a Tebra integration
     * Enable a tebra integration
     */
    async enableTebraIntegrationForBankUser(requestParameters: EnableTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.enableTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable the Charm integration
     * Disable the Charm integration
     */
    async fetchSupportIntegrationCharmRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/charm/fetch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable the Charm integration
     * Disable the Charm integration
     */
    async fetchSupportIntegrationCharm(): Promise<ObjectNoResponse> {
        const response = await this.fetchSupportIntegrationCharmRaw();
        return await response.value();
    }

    /**
     * Get CareCloud integrations for user
     * Get CareCloud integrations for user
     */
    async getCareCloudIntegrationForBankUserRaw(): Promise<runtime.ApiResponse<Array<CareCloudIntegrationResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/carecloud`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CareCloudIntegrationResponseFromJSON));
    }

    /**
     * Get CareCloud integrations for user
     * Get CareCloud integrations for user
     */
    async getCareCloudIntegrationForBankUser(): Promise<Array<CareCloudIntegrationResponse>> {
        const response = await this.getCareCloudIntegrationForBankUserRaw();
        return await response.value();
    }

    /**
     * Get CentralReach integrations for user
     * Get CentralReach integrations for user
     */
    async getCentralReachIntegrationForBankUserRaw(): Promise<runtime.ApiResponse<Array<CentralReachIntegrationResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/centralreach`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CentralReachIntegrationResponseFromJSON));
    }

    /**
     * Get CentralReach integrations for user
     * Get CentralReach integrations for user
     */
    async getCentralReachIntegrationForBankUser(): Promise<Array<CentralReachIntegrationResponse>> {
        const response = await this.getCentralReachIntegrationForBankUserRaw();
        return await response.value();
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getProviderApiIntegrationRaw(requestParameters: GetProviderApiIntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationApi>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getProviderApiIntegration(requestParameters: GetProviderApiIntegrationRequest): Promise<ProviderIntegrationApi> {
        const response = await this.getProviderApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getProviderHl7IntegrationRaw(requestParameters: GetProviderHl7IntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationHl7>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getProviderHl7Integration(requestParameters: GetProviderHl7IntegrationRequest): Promise<ProviderIntegrationHl7> {
        const response = await this.getProviderHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the Elation integration
     * Gets the Elation integration
     */
    async getProviderIntegrationElationRaw(): Promise<runtime.ApiResponse<ProviderIntegrationElation>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/elation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationElationFromJSON(jsonValue));
    }

    /**
     * Gets the Elation integration
     * Gets the Elation integration
     */
    async getProviderIntegrationElation(): Promise<ProviderIntegrationElation> {
        const response = await this.getProviderIntegrationElationRaw();
        return await response.value();
    }

    /**
     * Gets the Healthie integration
     * Gets the Healthie integration
     */
    async getProviderIntegrationHealthieRaw(): Promise<runtime.ApiResponse<ProviderIntegrationHealthie>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/healthie`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationHealthieFromJSON(jsonValue));
    }

    /**
     * Gets the Healthie integration
     * Gets the Healthie integration
     */
    async getProviderIntegrationHealthie(): Promise<ProviderIntegrationHealthie> {
        const response = await this.getProviderIntegrationHealthieRaw();
        return await response.value();
    }

    /**
     * Gets the SSO maintenance dashboard url
     * Gets the SSO maintenance dashboard url
     */
    async getProviderIntegrationSsoRaw(): Promise<runtime.ApiResponse<ProviderIntegrationSso>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sso`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationSsoFromJSON(jsonValue));
    }

    /**
     * Gets the SSO maintenance dashboard url
     * Gets the SSO maintenance dashboard url
     */
    async getProviderIntegrationSso(): Promise<ProviderIntegrationSso> {
        const response = await this.getProviderIntegrationSsoRaw();
        return await response.value();
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getProviderSftpIntegrationRaw(requestParameters: GetProviderSftpIntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getProviderSftpIntegration(requestParameters: GetProviderSftpIntegrationRequest): Promise<ProviderIntegrationSftp> {
        const response = await this.getProviderSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an sftp server export target
     * Gets an integration sftp server export target id
     */
    async getProviderSftpIntegrationExportRaw(requestParameters: GetProviderSftpIntegrationExportRequest): Promise<runtime.ApiResponse<ProviderIntegrationExportSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSftpIntegrationExport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/export/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationExportSftpFromJSON(jsonValue));
    }

    /**
     * Gets an sftp server export target
     * Gets an integration sftp server export target id
     */
    async getProviderSftpIntegrationExport(requestParameters: GetProviderSftpIntegrationExportRequest): Promise<ProviderIntegrationExportSftp> {
        const response = await this.getProviderSftpIntegrationExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getProviderSftpIntegrationImportRaw(requestParameters: GetProviderSftpIntegrationImportRequest): Promise<runtime.ApiResponse<ProviderIntegrationImportSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getProviderSftpIntegrationImport(requestParameters: GetProviderSftpIntegrationImportRequest): Promise<ProviderIntegrationImportSftp> {
        const response = await this.getProviderSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration terminal
     * Gets an integration terminal id
     */
    async getProviderTerminalIntegrationRaw(requestParameters: GetProviderTerminalIntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationTerminal>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderTerminalIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationTerminalFromJSON(jsonValue));
    }

    /**
     * Gets an integration terminal
     * Gets an integration terminal id
     */
    async getProviderTerminalIntegration(requestParameters: GetProviderTerminalIntegrationRequest): Promise<ProviderIntegrationTerminal> {
        const response = await this.getProviderTerminalIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getSupportApiIntegrationRaw(requestParameters: GetSupportApiIntegrationRequest): Promise<runtime.ApiResponse<SupportIntegrationApi>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getSupportApiIntegration(requestParameters: GetSupportApiIntegrationRequest): Promise<SupportIntegrationApi> {
        const response = await this.getSupportApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getSupportHl7IntegrationRaw(requestParameters: GetSupportHl7IntegrationRequest): Promise<runtime.ApiResponse<SupportIntegrationHl7>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getSupportHl7Integration(requestParameters: GetSupportHl7IntegrationRequest): Promise<SupportIntegrationHl7> {
        const response = await this.getSupportHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the Canvas integration
     * Gets the Canvas integration
     */
    async getSupportIntegrationCanvasRaw(): Promise<runtime.ApiResponse<SupportIntegrationCanvas>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/canvas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationCanvasFromJSON(jsonValue));
    }

    /**
     * Gets the Canvas integration
     * Gets the Canvas integration
     */
    async getSupportIntegrationCanvas(): Promise<SupportIntegrationCanvas> {
        const response = await this.getSupportIntegrationCanvasRaw();
        return await response.value();
    }

    /**
     * Gets the Charm integration
     * Gets the Charm integration
     */
    async getSupportIntegrationCharmRaw(): Promise<runtime.ApiResponse<SupportIntegrationCharm>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/charm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationCharmFromJSON(jsonValue));
    }

    /**
     * Gets the Charm integration
     * Gets the Charm integration
     */
    async getSupportIntegrationCharm(): Promise<SupportIntegrationCharm> {
        const response = await this.getSupportIntegrationCharmRaw();
        return await response.value();
    }

    /**
     * Gets the Elation integration
     * Gets the Elation integration
     */
    async getSupportIntegrationElationRaw(): Promise<runtime.ApiResponse<SupportIntegrationElation>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/elation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationElationFromJSON(jsonValue));
    }

    /**
     * Gets the Elation integration
     * Gets the Elation integration
     */
    async getSupportIntegrationElation(): Promise<SupportIntegrationElation> {
        const response = await this.getSupportIntegrationElationRaw();
        return await response.value();
    }

    /**
     * Gets the Enter Workflows integration
     * Gets the Enter Workflows integration
     */
    async getSupportIntegrationEnterWorkflowsRaw(): Promise<runtime.ApiResponse<SupportIntegrationEnterWorkflows>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/workflows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationEnterWorkflowsFromJSON(jsonValue));
    }

    /**
     * Gets the Enter Workflows integration
     * Gets the Enter Workflows integration
     */
    async getSupportIntegrationEnterWorkflows(): Promise<SupportIntegrationEnterWorkflows> {
        const response = await this.getSupportIntegrationEnterWorkflowsRaw();
        return await response.value();
    }

    /**
     * Gets the Healthie integration
     * Gets the Healthie integration
     */
    async getSupportIntegrationHealthieRaw(): Promise<runtime.ApiResponse<SupportIntegrationHealthie>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/healthie`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationHealthieFromJSON(jsonValue));
    }

    /**
     * Gets the Healthie integration
     * Gets the Healthie integration
     */
    async getSupportIntegrationHealthie(): Promise<SupportIntegrationHealthie> {
        const response = await this.getSupportIntegrationHealthieRaw();
        return await response.value();
    }

    /**
     * Gets the Nethealth integration
     * Gets the Nethealth integration
     */
    async getSupportIntegrationNethealthRaw(): Promise<runtime.ApiResponse<SupportIntegrationNetHealth>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/nethealth`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationNetHealthFromJSON(jsonValue));
    }

    /**
     * Gets the Nethealth integration
     * Gets the Nethealth integration
     */
    async getSupportIntegrationNethealth(): Promise<SupportIntegrationNetHealth> {
        const response = await this.getSupportIntegrationNethealthRaw();
        return await response.value();
    }

    /**
     * Gets the Royal integration
     * Gets the Royal integration
     */
    async getSupportIntegrationRoyalRaw(): Promise<runtime.ApiResponse<SupportIntegrationRoyal>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/royal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationRoyalFromJSON(jsonValue));
    }

    /**
     * Gets the Royal integration
     * Gets the Royal integration
     */
    async getSupportIntegrationRoyal(): Promise<SupportIntegrationRoyal> {
        const response = await this.getSupportIntegrationRoyalRaw();
        return await response.value();
    }

    /**
     * Gets the Royal document insurance card
     * Gets the Royal document insurance card
     */
    async getSupportIntegrationRoyalDocumentInsuranceCardRaw(requestParameters: GetSupportIntegrationRoyalDocumentInsuranceCardRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportIntegrationRoyalDocumentInsuranceCard.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/royal/accession/{id}/document/insurance_card`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets the Royal document insurance card
     * Gets the Royal document insurance card
     */
    async getSupportIntegrationRoyalDocumentInsuranceCard(requestParameters: GetSupportIntegrationRoyalDocumentInsuranceCardRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.getSupportIntegrationRoyalDocumentInsuranceCardRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the Royal document report
     * Gets the Royal document report
     */
    async getSupportIntegrationRoyalDocumentReportRaw(requestParameters: GetSupportIntegrationRoyalDocumentReportRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportIntegrationRoyalDocumentReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/royal/accession/{id}/document/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets the Royal document report
     * Gets the Royal document report
     */
    async getSupportIntegrationRoyalDocumentReport(requestParameters: GetSupportIntegrationRoyalDocumentReportRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.getSupportIntegrationRoyalDocumentReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the SSO maintenance dashboard url
     * Gets the SSO maintenance dashboard url
     */
    async getSupportIntegrationSsoRaw(): Promise<runtime.ApiResponse<SupportIntegrationSso>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sso`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationSsoFromJSON(jsonValue));
    }

    /**
     * Gets the SSO maintenance dashboard url
     * Gets the SSO maintenance dashboard url
     */
    async getSupportIntegrationSso(): Promise<SupportIntegrationSso> {
        const response = await this.getSupportIntegrationSsoRaw();
        return await response.value();
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getSupportSftpIntegrationRaw(requestParameters: GetSupportSftpIntegrationRequest): Promise<runtime.ApiResponse<SupportIntegrationSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getSupportSftpIntegration(requestParameters: GetSupportSftpIntegrationRequest): Promise<SupportIntegrationSftp> {
        const response = await this.getSupportSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an sftp server export target
     * Gets an integration sftp server export target id
     */
    async getSupportSftpIntegrationExportRaw(requestParameters: GetSupportSftpIntegrationExportRequest): Promise<runtime.ApiResponse<SupportIntegrationExportSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSftpIntegrationExport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/export/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationExportSftpFromJSON(jsonValue));
    }

    /**
     * Gets an sftp server export target
     * Gets an integration sftp server export target id
     */
    async getSupportSftpIntegrationExport(requestParameters: GetSupportSftpIntegrationExportRequest): Promise<SupportIntegrationExportSftp> {
        const response = await this.getSupportSftpIntegrationExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getSupportSftpIntegrationImportRaw(requestParameters: GetSupportSftpIntegrationImportRequest): Promise<runtime.ApiResponse<SupportIntegrationImportSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getSupportSftpIntegrationImport(requestParameters: GetSupportSftpIntegrationImportRequest): Promise<SupportIntegrationImportSftp> {
        const response = await this.getSupportSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Tebra integrations for user
     * Get Tebra integrations for user
     */
    async getTebraIntegrationForBankUserRaw(): Promise<runtime.ApiResponse<Array<TebraIntegrationResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/tebra`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TebraIntegrationResponseFromJSON));
    }

    /**
     * Get Tebra integrations for user
     * Get Tebra integrations for user
     */
    async getTebraIntegrationForBankUser(): Promise<Array<TebraIntegrationResponse>> {
        const response = await this.getTebraIntegrationForBankUserRaw();
        return await response.value();
    }

    /**
     * Send an inbound ADT to Experity to update records
     * Send an inbound ADT to Experity to update records
     */
    async inboundSupportExperityAdtRaw(requestParameters: InboundSupportExperityAdtRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling inboundSupportExperityAdt.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'text/plain';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/experity/inbound/hl7/adt/a08`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Send an inbound ADT to Experity to update records
     * Send an inbound ADT to Experity to update records
     */
    async inboundSupportExperityAdt(requestParameters: InboundSupportExperityAdtRequest): Promise<ObjectNoResponse> {
        const response = await this.inboundSupportExperityAdtRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a ModMed ingestion
     * Create a ModMed ingestion
     */
    async ingestSupportIntegrationModMedRaw(requestParameters: IngestSupportIntegrationModMedRequest): Promise<runtime.ApiResponse<SupportIntegrationModMedIngestion>> {
        if (requestParameters['supportIngestModMedPayload'] === null || requestParameters['supportIngestModMedPayload'] === undefined) {
            throw new runtime.RequiredError('supportIngestModMedPayload','Required parameter requestParameters.supportIngestModMedPayload was null or undefined when calling ingestSupportIntegrationModMed.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/modmed/ingestion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIngestModMedPayloadToJSON(requestParameters['supportIngestModMedPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationModMedIngestionFromJSON(jsonValue));
    }

    /**
     * Create a ModMed ingestion
     * Create a ModMed ingestion
     */
    async ingestSupportIntegrationModMed(requestParameters: IngestSupportIntegrationModMedRequest): Promise<SupportIntegrationModMedIngestion> {
        const response = await this.ingestSupportIntegrationModMedRaw(requestParameters);
        return await response.value();
    }

    /**
     * Invalidate an Elation bill
     * Invalidate an Elation bill
     */
    async invalidateSupportIntegrationElationBillRaw(requestParameters: InvalidateSupportIntegrationElationBillRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling invalidateSupportIntegrationElationBill.');
        }

        if (requestParameters['supportInvalidateElationBillPayload'] === null || requestParameters['supportInvalidateElationBillPayload'] === undefined) {
            throw new runtime.RequiredError('supportInvalidateElationBillPayload','Required parameter requestParameters.supportInvalidateElationBillPayload was null or undefined when calling invalidateSupportIntegrationElationBill.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/elation/bill/{id}/invalidate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportInvalidateElationBillPayloadToJSON(requestParameters['supportInvalidateElationBillPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Invalidate an Elation bill
     * Invalidate an Elation bill
     */
    async invalidateSupportIntegrationElationBill(requestParameters: InvalidateSupportIntegrationElationBillRequest): Promise<ObjectNoResponse> {
        const response = await this.invalidateSupportIntegrationElationBillRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of integration apis
     * Get a list of integration apis
     */
    async listProviderApiIntegrationsRaw(requestParameters: ListProviderApiIntegrationsRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationApi>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationApiFromJSON));
    }

    /**
     * Gets a list of integration apis
     * Get a list of integration apis
     */
    async listProviderApiIntegrations(requestParameters: ListProviderApiIntegrationsRequest): Promise<Array<ProviderIntegrationApi>> {
        const response = await this.listProviderApiIntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listProviderApplicationSftpRaw(requestParameters: ListProviderApplicationSftpRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationSftpFromJSON));
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listProviderApplicationSftp(requestParameters: ListProviderApplicationSftpRequest): Promise<Array<ProviderIntegrationSftp>> {
        const response = await this.listProviderApplicationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listProviderHl7IntegrationsRaw(requestParameters: ListProviderHl7IntegrationsRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationHl7>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationHl7FromJSON));
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listProviderHl7Integrations(requestParameters: ListProviderHl7IntegrationsRequest): Promise<Array<ProviderIntegrationHl7>> {
        const response = await this.listProviderHl7IntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp server export targets
     * Get a list of sftp server export targets
     */
    async listProviderIntegrationExportSftpRaw(requestParameters: ListProviderIntegrationExportSftpRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationExportSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/export/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationExportSftpFromJSON));
    }

    /**
     * Gets a list of sftp server export targets
     * Get a list of sftp server export targets
     */
    async listProviderIntegrationExportSftp(requestParameters: ListProviderIntegrationExportSftpRequest): Promise<Array<ProviderIntegrationExportSftp>> {
        const response = await this.listProviderIntegrationExportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listProviderIntegrationImportSftpRaw(requestParameters: ListProviderIntegrationImportSftpRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationImportSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationImportSftpFromJSON));
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listProviderIntegrationImportSftp(requestParameters: ListProviderIntegrationImportSftpRequest): Promise<Array<ProviderIntegrationImportSftp>> {
        const response = await this.listProviderIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of terminal integration tokens
     * Get a list of terminal integration tokens
     */
    async listProviderTerminalIntegrationTokensRaw(requestParameters: ListProviderTerminalIntegrationTokensRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationTerminalToken>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listProviderTerminalIntegrationTokens.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal/{id}/token`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationTerminalTokenFromJSON));
    }

    /**
     * Gets a list of terminal integration tokens
     * Get a list of terminal integration tokens
     */
    async listProviderTerminalIntegrationTokens(requestParameters: ListProviderTerminalIntegrationTokensRequest): Promise<Array<ProviderIntegrationTerminalToken>> {
        const response = await this.listProviderTerminalIntegrationTokensRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of terminal integrations
     * Get a list of terminal integrations
     */
    async listProviderTerminalIntegrationsRaw(requestParameters: ListProviderTerminalIntegrationsRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationTerminal>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationTerminalFromJSON));
    }

    /**
     * Gets a list of terminal integrations
     * Get a list of terminal integrations
     */
    async listProviderTerminalIntegrations(requestParameters: ListProviderTerminalIntegrationsRequest): Promise<Array<ProviderIntegrationTerminal>> {
        const response = await this.listProviderTerminalIntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of integration APIs
     * Get a list of integration APIs
     */
    async listSupportApiIntegrationsRaw(requestParameters: ListSupportApiIntegrationsRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationApi>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationApiFromJSON));
    }

    /**
     * Gets a list of integration APIs
     * Get a list of integration APIs
     */
    async listSupportApiIntegrations(requestParameters: ListSupportApiIntegrationsRequest): Promise<Array<SupportIntegrationApi>> {
        const response = await this.listSupportApiIntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listSupportApplicationSftpRaw(requestParameters: ListSupportApplicationSftpRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationSftpFromJSON));
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listSupportApplicationSftp(requestParameters: ListSupportApplicationSftpRequest): Promise<Array<SupportIntegrationSftp>> {
        const response = await this.listSupportApplicationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listSupportHl7IntegrationsRaw(requestParameters: ListSupportHl7IntegrationsRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationHl7>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationHl7FromJSON));
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listSupportHl7Integrations(requestParameters: ListSupportHl7IntegrationsRequest): Promise<Array<SupportIntegrationHl7>> {
        const response = await this.listSupportHl7IntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp server export targets
     * Get a list of sftp server export targets
     */
    async listSupportIntegrationExportSftpRaw(requestParameters: ListSupportIntegrationExportSftpRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationExportSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/export/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationExportSftpFromJSON));
    }

    /**
     * Gets a list of sftp server export targets
     * Get a list of sftp server export targets
     */
    async listSupportIntegrationExportSftp(requestParameters: ListSupportIntegrationExportSftpRequest): Promise<Array<SupportIntegrationExportSftp>> {
        const response = await this.listSupportIntegrationExportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listSupportIntegrationImportSftpRaw(requestParameters: ListSupportIntegrationImportSftpRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationImportSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationImportSftpFromJSON));
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listSupportIntegrationImportSftp(requestParameters: ListSupportIntegrationImportSftpRequest): Promise<Array<SupportIntegrationImportSftp>> {
        const response = await this.listSupportIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create integration api
     * Create an integration api
     */
    async postProviderIntegrationApiRaw(requestParameters: PostProviderIntegrationApiRequest): Promise<runtime.ApiResponse<ProviderIntegrationApi>> {
        if (requestParameters['providerCreateIntegrationApiPayload'] === null || requestParameters['providerCreateIntegrationApiPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationApiPayload','Required parameter requestParameters.providerCreateIntegrationApiPayload was null or undefined when calling postProviderIntegrationApi.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationApiPayloadToJSON(requestParameters['providerCreateIntegrationApiPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Create integration api
     * Create an integration api
     */
    async postProviderIntegrationApi(requestParameters: PostProviderIntegrationApiRequest): Promise<ProviderIntegrationApi> {
        const response = await this.postProviderIntegrationApiRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an Elation integration
     * Create an Elation integration
     */
    async postProviderIntegrationElationRaw(requestParameters: PostProviderIntegrationElationRequest): Promise<runtime.ApiResponse<ProviderIntegrationElation>> {
        if (requestParameters['providerCreateIntegrationElationPayload'] === null || requestParameters['providerCreateIntegrationElationPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationElationPayload','Required parameter requestParameters.providerCreateIntegrationElationPayload was null or undefined when calling postProviderIntegrationElation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/elation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationElationPayloadToJSON(requestParameters['providerCreateIntegrationElationPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationElationFromJSON(jsonValue));
    }

    /**
     * Create an Elation integration
     * Create an Elation integration
     */
    async postProviderIntegrationElation(requestParameters: PostProviderIntegrationElationRequest): Promise<ProviderIntegrationElation> {
        const response = await this.postProviderIntegrationElationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration export SFTP server
     * Create an integration export SFTP server
     */
    async postProviderIntegrationExportSftpRaw(requestParameters: PostProviderIntegrationExportSftpRequest): Promise<runtime.ApiResponse<ProviderIntegrationExportSftp>> {
        if (requestParameters['providerCreateIntegrationExportSftpPayload'] === null || requestParameters['providerCreateIntegrationExportSftpPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationExportSftpPayload','Required parameter requestParameters.providerCreateIntegrationExportSftpPayload was null or undefined when calling postProviderIntegrationExportSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/export/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationExportSftpPayloadToJSON(requestParameters['providerCreateIntegrationExportSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationExportSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration export SFTP server
     * Create an integration export SFTP server
     */
    async postProviderIntegrationExportSftp(requestParameters: PostProviderIntegrationExportSftpRequest): Promise<ProviderIntegrationExportSftp> {
        const response = await this.postProviderIntegrationExportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Healthie integration
     * Create a Healthie integration
     */
    async postProviderIntegrationHealthieRaw(requestParameters: PostProviderIntegrationHealthieRequest): Promise<runtime.ApiResponse<ProviderIntegrationHealthie>> {
        if (requestParameters['providerIntegrationHealthiePayload'] === null || requestParameters['providerIntegrationHealthiePayload'] === undefined) {
            throw new runtime.RequiredError('providerIntegrationHealthiePayload','Required parameter requestParameters.providerIntegrationHealthiePayload was null or undefined when calling postProviderIntegrationHealthie.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/healthie`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderIntegrationHealthiePayloadToJSON(requestParameters['providerIntegrationHealthiePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationHealthieFromJSON(jsonValue));
    }

    /**
     * Create a Healthie integration
     * Create a Healthie integration
     */
    async postProviderIntegrationHealthie(requestParameters: PostProviderIntegrationHealthieRequest): Promise<ProviderIntegrationHealthie> {
        const response = await this.postProviderIntegrationHealthieRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postProviderIntegrationHl7Raw(requestParameters: PostProviderIntegrationHl7Request): Promise<runtime.ApiResponse<ProviderIntegrationHl7>> {
        if (requestParameters['providerCreateIntegrationHl7Payload'] === null || requestParameters['providerCreateIntegrationHl7Payload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationHl7Payload','Required parameter requestParameters.providerCreateIntegrationHl7Payload was null or undefined when calling postProviderIntegrationHl7.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationHl7PayloadToJSON(requestParameters['providerCreateIntegrationHl7Payload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postProviderIntegrationHl7(requestParameters: PostProviderIntegrationHl7Request): Promise<ProviderIntegrationHl7> {
        const response = await this.postProviderIntegrationHl7Raw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postProviderIntegrationImportSftpRaw(requestParameters: PostProviderIntegrationImportSftpRequest): Promise<runtime.ApiResponse<ProviderIntegrationImportSftp>> {
        if (requestParameters['providerCreateIntegrationImportSftpPayload'] === null || requestParameters['providerCreateIntegrationImportSftpPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationImportSftpPayload','Required parameter requestParameters.providerCreateIntegrationImportSftpPayload was null or undefined when calling postProviderIntegrationImportSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationImportSftpPayloadToJSON(requestParameters['providerCreateIntegrationImportSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postProviderIntegrationImportSftp(requestParameters: PostProviderIntegrationImportSftpRequest): Promise<ProviderIntegrationImportSftp> {
        const response = await this.postProviderIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postProviderIntegrationSftpRaw(requestParameters: PostProviderIntegrationSftpRequest): Promise<runtime.ApiResponse<ProviderIntegrationSftp>> {
        if (requestParameters['providerCreateIntegrationSftpPayload'] === null || requestParameters['providerCreateIntegrationSftpPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationSftpPayload','Required parameter requestParameters.providerCreateIntegrationSftpPayload was null or undefined when calling postProviderIntegrationSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationSftpPayloadToJSON(requestParameters['providerCreateIntegrationSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postProviderIntegrationSftp(requestParameters: PostProviderIntegrationSftpRequest): Promise<ProviderIntegrationSftp> {
        const response = await this.postProviderIntegrationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration Terminal
     * Create an integration Terminal
     */
    async postProviderIntegrationTerminalRaw(): Promise<runtime.ApiResponse<ProviderIntegrationTerminal>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationTerminalFromJSON(jsonValue));
    }

    /**
     * Create an integration Terminal
     * Create an integration Terminal
     */
    async postProviderIntegrationTerminal(): Promise<ProviderIntegrationTerminal> {
        const response = await this.postProviderIntegrationTerminalRaw();
        return await response.value();
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postProviderIntegrationWebhooksRaw(): Promise<runtime.ApiResponse<ProviderIntegrationWebhooks>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/webhooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationWebhooksFromJSON(jsonValue));
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postProviderIntegrationWebhooks(): Promise<ProviderIntegrationWebhooks> {
        const response = await this.postProviderIntegrationWebhooksRaw();
        return await response.value();
    }

    /**
     * Create a professional from a coding
     * Create an integration api
     */
    async postSupportIntegrationApiRaw(requestParameters: PostSupportIntegrationApiRequest): Promise<runtime.ApiResponse<SupportIntegrationApi>> {
        if (requestParameters['supportCreateIntegrationApiPayload'] === null || requestParameters['supportCreateIntegrationApiPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationApiPayload','Required parameter requestParameters.supportCreateIntegrationApiPayload was null or undefined when calling postSupportIntegrationApi.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationApiPayloadToJSON(requestParameters['supportCreateIntegrationApiPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Create a professional from a coding
     * Create an integration api
     */
    async postSupportIntegrationApi(requestParameters: PostSupportIntegrationApiRequest): Promise<SupportIntegrationApi> {
        const response = await this.postSupportIntegrationApiRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Canvas integration
     * Create a Canvas integration
     */
    async postSupportIntegrationCanvasRaw(requestParameters: PostSupportIntegrationCanvasRequest): Promise<runtime.ApiResponse<SupportIntegrationCanvas>> {
        if (requestParameters['supportCreateIntegrationCanvasPayload'] === null || requestParameters['supportCreateIntegrationCanvasPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationCanvasPayload','Required parameter requestParameters.supportCreateIntegrationCanvasPayload was null or undefined when calling postSupportIntegrationCanvas.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/canvas`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationCanvasPayloadToJSON(requestParameters['supportCreateIntegrationCanvasPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationCanvasFromJSON(jsonValue));
    }

    /**
     * Create a Canvas integration
     * Create a Canvas integration
     */
    async postSupportIntegrationCanvas(requestParameters: PostSupportIntegrationCanvasRequest): Promise<SupportIntegrationCanvas> {
        const response = await this.postSupportIntegrationCanvasRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Charm integration
     * Create a Charm integration
     */
    async postSupportIntegrationCharmRaw(requestParameters: PostSupportIntegrationCharmRequest): Promise<runtime.ApiResponse<SupportIntegrationCharm>> {
        if (requestParameters['supportCreateIntegrationCharmPayload'] === null || requestParameters['supportCreateIntegrationCharmPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationCharmPayload','Required parameter requestParameters.supportCreateIntegrationCharmPayload was null or undefined when calling postSupportIntegrationCharm.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/charm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationCharmPayloadToJSON(requestParameters['supportCreateIntegrationCharmPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationCharmFromJSON(jsonValue));
    }

    /**
     * Create a Charm integration
     * Create a Charm integration
     */
    async postSupportIntegrationCharm(requestParameters: PostSupportIntegrationCharmRequest): Promise<SupportIntegrationCharm> {
        const response = await this.postSupportIntegrationCharmRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an Elation integration
     * Create an Elation integration
     */
    async postSupportIntegrationElationRaw(requestParameters: PostSupportIntegrationElationRequest): Promise<runtime.ApiResponse<SupportIntegrationElation>> {
        if (requestParameters['supportCreateIntegrationElationPayload'] === null || requestParameters['supportCreateIntegrationElationPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationElationPayload','Required parameter requestParameters.supportCreateIntegrationElationPayload was null or undefined when calling postSupportIntegrationElation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/elation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationElationPayloadToJSON(requestParameters['supportCreateIntegrationElationPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationElationFromJSON(jsonValue));
    }

    /**
     * Create an Elation integration
     * Create an Elation integration
     */
    async postSupportIntegrationElation(requestParameters: PostSupportIntegrationElationRequest): Promise<SupportIntegrationElation> {
        const response = await this.postSupportIntegrationElationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Enter Workflows integration
     * Create a Enter Workflows integration
     */
    async postSupportIntegrationEnterWorkflowsRaw(requestParameters: PostSupportIntegrationEnterWorkflowsRequest): Promise<runtime.ApiResponse<SupportIntegrationEnterWorkflows>> {
        if (requestParameters['supportCreateIntegrationEnterWorkflowsPayload'] === null || requestParameters['supportCreateIntegrationEnterWorkflowsPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationEnterWorkflowsPayload','Required parameter requestParameters.supportCreateIntegrationEnterWorkflowsPayload was null or undefined when calling postSupportIntegrationEnterWorkflows.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/workflows`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationEnterWorkflowsPayloadToJSON(requestParameters['supportCreateIntegrationEnterWorkflowsPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationEnterWorkflowsFromJSON(jsonValue));
    }

    /**
     * Create a Enter Workflows integration
     * Create a Enter Workflows integration
     */
    async postSupportIntegrationEnterWorkflows(requestParameters: PostSupportIntegrationEnterWorkflowsRequest): Promise<SupportIntegrationEnterWorkflows> {
        const response = await this.postSupportIntegrationEnterWorkflowsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration export SFTP server
     * Create an integration export SFTP server
     */
    async postSupportIntegrationExportSftpRaw(requestParameters: PostSupportIntegrationExportSftpRequest): Promise<runtime.ApiResponse<SupportIntegrationExportSftp>> {
        if (requestParameters['supportCreateIntegrationExportSftpPayload'] === null || requestParameters['supportCreateIntegrationExportSftpPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationExportSftpPayload','Required parameter requestParameters.supportCreateIntegrationExportSftpPayload was null or undefined when calling postSupportIntegrationExportSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/export/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationExportSftpPayloadToJSON(requestParameters['supportCreateIntegrationExportSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationExportSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration export SFTP server
     * Create an integration export SFTP server
     */
    async postSupportIntegrationExportSftp(requestParameters: PostSupportIntegrationExportSftpRequest): Promise<SupportIntegrationExportSftp> {
        const response = await this.postSupportIntegrationExportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Healthie integration
     * Create a Healthie integration
     */
    async postSupportIntegrationHealthieRaw(requestParameters: PostSupportIntegrationHealthieRequest): Promise<runtime.ApiResponse<SupportIntegrationHealthie>> {
        if (requestParameters['supportIntegrationHealthiePayload'] === null || requestParameters['supportIntegrationHealthiePayload'] === undefined) {
            throw new runtime.RequiredError('supportIntegrationHealthiePayload','Required parameter requestParameters.supportIntegrationHealthiePayload was null or undefined when calling postSupportIntegrationHealthie.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/healthie`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIntegrationHealthiePayloadToJSON(requestParameters['supportIntegrationHealthiePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationHealthieFromJSON(jsonValue));
    }

    /**
     * Create a Healthie integration
     * Create a Healthie integration
     */
    async postSupportIntegrationHealthie(requestParameters: PostSupportIntegrationHealthieRequest): Promise<SupportIntegrationHealthie> {
        const response = await this.postSupportIntegrationHealthieRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postSupportIntegrationHl7Raw(requestParameters: PostSupportIntegrationHl7Request): Promise<runtime.ApiResponse<SupportIntegrationHl7>> {
        if (requestParameters['supportCreateIntegrationHl7Payload'] === null || requestParameters['supportCreateIntegrationHl7Payload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationHl7Payload','Required parameter requestParameters.supportCreateIntegrationHl7Payload was null or undefined when calling postSupportIntegrationHl7.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationHl7PayloadToJSON(requestParameters['supportCreateIntegrationHl7Payload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postSupportIntegrationHl7(requestParameters: PostSupportIntegrationHl7Request): Promise<SupportIntegrationHl7> {
        const response = await this.postSupportIntegrationHl7Raw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postSupportIntegrationImportSftpRaw(requestParameters: PostSupportIntegrationImportSftpRequest): Promise<runtime.ApiResponse<SupportIntegrationImportSftp>> {
        if (requestParameters['supportCreateIntegrationImportSftpPayload'] === null || requestParameters['supportCreateIntegrationImportSftpPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationImportSftpPayload','Required parameter requestParameters.supportCreateIntegrationImportSftpPayload was null or undefined when calling postSupportIntegrationImportSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationImportSftpPayloadToJSON(requestParameters['supportCreateIntegrationImportSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postSupportIntegrationImportSftp(requestParameters: PostSupportIntegrationImportSftpRequest): Promise<SupportIntegrationImportSftp> {
        const response = await this.postSupportIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Nethealth integration
     * Create a Nethealth integration
     */
    async postSupportIntegrationNethealthRaw(requestParameters: PostSupportIntegrationNethealthRequest): Promise<runtime.ApiResponse<SupportIntegrationNetHealth>> {
        if (requestParameters['supportIntegrationNetHealthPayload'] === null || requestParameters['supportIntegrationNetHealthPayload'] === undefined) {
            throw new runtime.RequiredError('supportIntegrationNetHealthPayload','Required parameter requestParameters.supportIntegrationNetHealthPayload was null or undefined when calling postSupportIntegrationNethealth.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/nethealth`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIntegrationNetHealthPayloadToJSON(requestParameters['supportIntegrationNetHealthPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationNetHealthFromJSON(jsonValue));
    }

    /**
     * Create a Nethealth integration
     * Create a Nethealth integration
     */
    async postSupportIntegrationNethealth(requestParameters: PostSupportIntegrationNethealthRequest): Promise<SupportIntegrationNetHealth> {
        const response = await this.postSupportIntegrationNethealthRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Royal integration
     * Create a Royal integration
     */
    async postSupportIntegrationRoyalRaw(requestParameters: PostSupportIntegrationRoyalRequest): Promise<runtime.ApiResponse<SupportIntegrationRoyal>> {
        if (requestParameters['supportIntegrationRoyalPayload'] === null || requestParameters['supportIntegrationRoyalPayload'] === undefined) {
            throw new runtime.RequiredError('supportIntegrationRoyalPayload','Required parameter requestParameters.supportIntegrationRoyalPayload was null or undefined when calling postSupportIntegrationRoyal.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/royal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIntegrationRoyalPayloadToJSON(requestParameters['supportIntegrationRoyalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationRoyalFromJSON(jsonValue));
    }

    /**
     * Create a Royal integration
     * Create a Royal integration
     */
    async postSupportIntegrationRoyal(requestParameters: PostSupportIntegrationRoyalRequest): Promise<SupportIntegrationRoyal> {
        const response = await this.postSupportIntegrationRoyalRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postSupportIntegrationSftpRaw(requestParameters: PostSupportIntegrationSftpRequest): Promise<runtime.ApiResponse<SupportIntegrationSftp>> {
        if (requestParameters['supportCreateIntegrationSftpPayload'] === null || requestParameters['supportCreateIntegrationSftpPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationSftpPayload','Required parameter requestParameters.supportCreateIntegrationSftpPayload was null or undefined when calling postSupportIntegrationSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationSftpPayloadToJSON(requestParameters['supportCreateIntegrationSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postSupportIntegrationSftp(requestParameters: PostSupportIntegrationSftpRequest): Promise<SupportIntegrationSftp> {
        const response = await this.postSupportIntegrationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postSupportIntegrationWebhooksRaw(): Promise<runtime.ApiResponse<SupportIntegrationWebhooks>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/webhooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationWebhooksFromJSON(jsonValue));
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postSupportIntegrationWebhooks(): Promise<SupportIntegrationWebhooks> {
        const response = await this.postSupportIntegrationWebhooksRaw();
        return await response.value();
    }

    /**
     * Refund a patient through the Royal integration
     * Refund a patient through the Royal integration
     */
    async postSupportRoyalCollectionPatientRefundRaw(requestParameters: PostSupportRoyalCollectionPatientRefundRequest): Promise<runtime.ApiResponse<SupportIntegrationRoyalCollectionRefundResponse>> {
        if (requestParameters['supportIntegrationRoyalCollectionPatientRefundPayload'] === null || requestParameters['supportIntegrationRoyalCollectionPatientRefundPayload'] === undefined) {
            throw new runtime.RequiredError('supportIntegrationRoyalCollectionPatientRefundPayload','Required parameter requestParameters.supportIntegrationRoyalCollectionPatientRefundPayload was null or undefined when calling postSupportRoyalCollectionPatientRefund.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/royal_collection/patient_refund`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIntegrationRoyalCollectionPatientRefundPayloadToJSON(requestParameters['supportIntegrationRoyalCollectionPatientRefundPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationRoyalCollectionRefundResponseFromJSON(jsonValue));
    }

    /**
     * Refund a patient through the Royal integration
     * Refund a patient through the Royal integration
     */
    async postSupportRoyalCollectionPatientRefund(requestParameters: PostSupportRoyalCollectionPatientRefundRequest): Promise<SupportIntegrationRoyalCollectionRefundResponse> {
        const response = await this.postSupportRoyalCollectionPatientRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a CareCloud integration
     * Create a carecloud integration
     */
    async providerCreateCareCloudIntegrationForBankUserRaw(requestParameters: ProviderCreateCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['careCloudIntegrationCreateRequest'] === null || requestParameters['careCloudIntegrationCreateRequest'] === undefined) {
            throw new runtime.RequiredError('careCloudIntegrationCreateRequest','Required parameter requestParameters.careCloudIntegrationCreateRequest was null or undefined when calling providerCreateCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/carecloud`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CareCloudIntegrationCreateRequestToJSON(requestParameters['careCloudIntegrationCreateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a CareCloud integration
     * Create a carecloud integration
     */
    async providerCreateCareCloudIntegrationForBankUser(requestParameters: ProviderCreateCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerCreateCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a CentralReach integration
     * Create a CentralReach integration
     */
    async providerCreateCentralReachIntegrationForBankUserRaw(requestParameters: ProviderCreateCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['centralReachIntegrationCreateRequest'] === null || requestParameters['centralReachIntegrationCreateRequest'] === undefined) {
            throw new runtime.RequiredError('centralReachIntegrationCreateRequest','Required parameter requestParameters.centralReachIntegrationCreateRequest was null or undefined when calling providerCreateCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/centralreach`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CentralReachIntegrationCreateRequestToJSON(requestParameters['centralReachIntegrationCreateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a CentralReach integration
     * Create a CentralReach integration
     */
    async providerCreateCentralReachIntegrationForBankUser(requestParameters: ProviderCreateCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerCreateCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a Tebra integration
     * Create a tebra integration
     */
    async providerCreateTebraIntegrationForBankUserRaw(requestParameters: ProviderCreateTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['tebraIntegrationCreateRequest'] === null || requestParameters['tebraIntegrationCreateRequest'] === undefined) {
            throw new runtime.RequiredError('tebraIntegrationCreateRequest','Required parameter requestParameters.tebraIntegrationCreateRequest was null or undefined when calling providerCreateTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/tebra`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TebraIntegrationCreateRequestToJSON(requestParameters['tebraIntegrationCreateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a Tebra integration
     * Create a tebra integration
     */
    async providerCreateTebraIntegrationForBankUser(requestParameters: ProviderCreateTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerCreateTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a CareCloud integration
     * Disable a carecloud integration
     */
    async providerDisableCareCloudIntegrationForBankUserRaw(requestParameters: ProviderDisableCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerDisableCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/carecloud/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Disable a CareCloud integration
     * Disable a carecloud integration
     */
    async providerDisableCareCloudIntegrationForBankUser(requestParameters: ProviderDisableCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerDisableCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a CentralReach integration
     * Disable a CentralReach integration
     */
    async providerDisableCentralReachIntegrationForBankUserRaw(requestParameters: ProviderDisableCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerDisableCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/centralreach/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Disable a CentralReach integration
     * Disable a CentralReach integration
     */
    async providerDisableCentralReachIntegrationForBankUser(requestParameters: ProviderDisableCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerDisableCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a Tebra integration
     * Disable a tebra integration
     */
    async providerDisableTebraIntegrationForBankUserRaw(requestParameters: ProviderDisableTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerDisableTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/tebra/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Disable a Tebra integration
     * Disable a tebra integration
     */
    async providerDisableTebraIntegrationForBankUser(requestParameters: ProviderDisableTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerDisableTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a CareCloud integration
     * Enable a carecloud integration
     */
    async providerEnableCareCloudIntegrationForBankUserRaw(requestParameters: ProviderEnableCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerEnableCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/carecloud/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Enable a CareCloud integration
     * Enable a carecloud integration
     */
    async providerEnableCareCloudIntegrationForBankUser(requestParameters: ProviderEnableCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerEnableCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a CentralReach integration
     * Enable a CentralReach integration
     */
    async providerEnableCentralReachIntegrationForBankUserRaw(requestParameters: ProviderEnableCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerEnableCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/centralreach/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Enable a CentralReach integration
     * Enable a CentralReach integration
     */
    async providerEnableCentralReachIntegrationForBankUser(requestParameters: ProviderEnableCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerEnableCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable a Tebra integration
     * Enable a tebra integration
     */
    async providerEnableTebraIntegrationForBankUserRaw(requestParameters: ProviderEnableTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerEnableTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/tebra/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Enable a Tebra integration
     * Enable a tebra integration
     */
    async providerEnableTebraIntegrationForBankUser(requestParameters: ProviderEnableTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerEnableTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get CareCloud integrations for user
     * Get CareCloud integrations for user
     */
    async providerGetCareCloudIntegrationForBankUserRaw(): Promise<runtime.ApiResponse<Array<CareCloudIntegrationResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/carecloud`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CareCloudIntegrationResponseFromJSON));
    }

    /**
     * Get CareCloud integrations for user
     * Get CareCloud integrations for user
     */
    async providerGetCareCloudIntegrationForBankUser(): Promise<Array<CareCloudIntegrationResponse>> {
        const response = await this.providerGetCareCloudIntegrationForBankUserRaw();
        return await response.value();
    }

    /**
     * Get CentralReach integrations for user
     * Get CentralReach integrations for user
     */
    async providerGetCentralReachIntegrationForBankUserRaw(): Promise<runtime.ApiResponse<Array<CentralReachIntegrationResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/centralreach`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CentralReachIntegrationResponseFromJSON));
    }

    /**
     * Get CentralReach integrations for user
     * Get CentralReach integrations for user
     */
    async providerGetCentralReachIntegrationForBankUser(): Promise<Array<CentralReachIntegrationResponse>> {
        const response = await this.providerGetCentralReachIntegrationForBankUserRaw();
        return await response.value();
    }

    /**
     * Get Tebra integrations for user
     * Get Tebra integrations for user
     */
    async providerGetTebraIntegrationForBankUserRaw(): Promise<runtime.ApiResponse<Array<TebraIntegrationResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/tebra`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TebraIntegrationResponseFromJSON));
    }

    /**
     * Get Tebra integrations for user
     * Get Tebra integrations for user
     */
    async providerGetTebraIntegrationForBankUser(): Promise<Array<TebraIntegrationResponse>> {
        const response = await this.providerGetTebraIntegrationForBankUserRaw();
        return await response.value();
    }

    /**
     * Update a CareCloud integration
     * Update a carecloud integration
     */
    async providerUpdateCareCloudIntegrationForBankUserRaw(requestParameters: ProviderUpdateCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerUpdateCareCloudIntegrationForBankUser.');
        }

        if (requestParameters['careCloudIntegrationUpdateRequest'] === null || requestParameters['careCloudIntegrationUpdateRequest'] === undefined) {
            throw new runtime.RequiredError('careCloudIntegrationUpdateRequest','Required parameter requestParameters.careCloudIntegrationUpdateRequest was null or undefined when calling providerUpdateCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/carecloud/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CareCloudIntegrationUpdateRequestToJSON(requestParameters['careCloudIntegrationUpdateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a CareCloud integration
     * Update a carecloud integration
     */
    async providerUpdateCareCloudIntegrationForBankUser(requestParameters: ProviderUpdateCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerUpdateCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a CentralReach integration
     * Update a CentralReach integration
     */
    async providerUpdateCentralReachIntegrationForBankUserRaw(requestParameters: ProviderUpdateCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerUpdateCentralReachIntegrationForBankUser.');
        }

        if (requestParameters['centralReachIntegrationUpdateRequest'] === null || requestParameters['centralReachIntegrationUpdateRequest'] === undefined) {
            throw new runtime.RequiredError('centralReachIntegrationUpdateRequest','Required parameter requestParameters.centralReachIntegrationUpdateRequest was null or undefined when calling providerUpdateCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/centralreach/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CentralReachIntegrationUpdateRequestToJSON(requestParameters['centralReachIntegrationUpdateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a CentralReach integration
     * Update a CentralReach integration
     */
    async providerUpdateCentralReachIntegrationForBankUser(requestParameters: ProviderUpdateCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerUpdateCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a Tebra integration
     * Update a tebra integration
     */
    async providerUpdateTebraIntegrationForBankUserRaw(requestParameters: ProviderUpdateTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling providerUpdateTebraIntegrationForBankUser.');
        }

        if (requestParameters['tebraIntegrationUpdateRequest'] === null || requestParameters['tebraIntegrationUpdateRequest'] === undefined) {
            throw new runtime.RequiredError('tebraIntegrationUpdateRequest','Required parameter requestParameters.tebraIntegrationUpdateRequest was null or undefined when calling providerUpdateTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/tebra/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TebraIntegrationUpdateRequestToJSON(requestParameters['tebraIntegrationUpdateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a Tebra integration
     * Update a tebra integration
     */
    async providerUpdateTebraIntegrationForBankUser(requestParameters: ProviderUpdateTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.providerUpdateTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reset a CentralReach encounter so the polling job processes it again
     * Reset the last updated date to re-trigger the encounter
     */
    async resetCentralReachEncounterByControlNumberRaw(requestParameters: ResetCentralReachEncounterByControlNumberRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling resetCentralReachEncounterByControlNumber.');
        }

        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling resetCentralReachEncounterByControlNumber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/centralreach/{id}/control/{cid}/reset_last_updated`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Reset a CentralReach encounter so the polling job processes it again
     * Reset the last updated date to re-trigger the encounter
     */
    async resetCentralReachEncounterByControlNumber(requestParameters: ResetCentralReachEncounterByControlNumberRequest): Promise<ObjectNoResponse> {
        const response = await this.resetCentralReachEncounterByControlNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     * Run an integration SFTP
     * Run the integration SFTP
     */
    async runSupportSftpIntegrationRaw(requestParameters: RunSupportSftpIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling runSupportSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp/{id}/run`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Run an integration SFTP
     * Run the integration SFTP
     */
    async runSupportSftpIntegration(requestParameters: RunSupportSftpIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.runSupportSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unlock a Healthie form answer group
     * Unlock a Healthie form answer group
     */
    async unlockSupportIntegrationHealthieFormAnswerGroupRaw(requestParameters: UnlockSupportIntegrationHealthieFormAnswerGroupRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unlockSupportIntegrationHealthieFormAnswerGroup.');
        }

        if (requestParameters['supportUnlockHealthieFormAnswerGroupPayload'] === null || requestParameters['supportUnlockHealthieFormAnswerGroupPayload'] === undefined) {
            throw new runtime.RequiredError('supportUnlockHealthieFormAnswerGroupPayload','Required parameter requestParameters.supportUnlockHealthieFormAnswerGroupPayload was null or undefined when calling unlockSupportIntegrationHealthieFormAnswerGroup.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/healthie/formanswergroup/{id}/unlock`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUnlockHealthieFormAnswerGroupPayloadToJSON(requestParameters['supportUnlockHealthieFormAnswerGroupPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Unlock a Healthie form answer group
     * Unlock a Healthie form answer group
     */
    async unlockSupportIntegrationHealthieFormAnswerGroup(requestParameters: UnlockSupportIntegrationHealthieFormAnswerGroupRequest): Promise<ObjectNoResponse> {
        const response = await this.unlockSupportIntegrationHealthieFormAnswerGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a CareCloud integration
     * Update a carecloud integration
     */
    async updateCareCloudIntegrationForBankUserRaw(requestParameters: UpdateCareCloudIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCareCloudIntegrationForBankUser.');
        }

        if (requestParameters['careCloudIntegrationUpdateRequest'] === null || requestParameters['careCloudIntegrationUpdateRequest'] === undefined) {
            throw new runtime.RequiredError('careCloudIntegrationUpdateRequest','Required parameter requestParameters.careCloudIntegrationUpdateRequest was null or undefined when calling updateCareCloudIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/carecloud/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CareCloudIntegrationUpdateRequestToJSON(requestParameters['careCloudIntegrationUpdateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a CareCloud integration
     * Update a carecloud integration
     */
    async updateCareCloudIntegrationForBankUser(requestParameters: UpdateCareCloudIntegrationForBankUserRequest): Promise<string> {
        const response = await this.updateCareCloudIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a CentralReach integration
     * Update a CentralReach integration
     */
    async updateCentralReachIntegrationForBankUserRaw(requestParameters: UpdateCentralReachIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCentralReachIntegrationForBankUser.');
        }

        if (requestParameters['centralReachIntegrationUpdateRequest'] === null || requestParameters['centralReachIntegrationUpdateRequest'] === undefined) {
            throw new runtime.RequiredError('centralReachIntegrationUpdateRequest','Required parameter requestParameters.centralReachIntegrationUpdateRequest was null or undefined when calling updateCentralReachIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/centralreach/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CentralReachIntegrationUpdateRequestToJSON(requestParameters['centralReachIntegrationUpdateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a CentralReach integration
     * Update a CentralReach integration
     */
    async updateCentralReachIntegrationForBankUser(requestParameters: UpdateCentralReachIntegrationForBankUserRequest): Promise<string> {
        const response = await this.updateCentralReachIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a Healthie integration details
     * Update a Healthie integration details
     */
    async updateProviderIntegrationHealthieRaw(requestParameters: UpdateProviderIntegrationHealthieRequest): Promise<runtime.ApiResponse<ProviderIntegrationHealthie>> {
        if (requestParameters['providerIntegrationHealthiePayload'] === null || requestParameters['providerIntegrationHealthiePayload'] === undefined) {
            throw new runtime.RequiredError('providerIntegrationHealthiePayload','Required parameter requestParameters.providerIntegrationHealthiePayload was null or undefined when calling updateProviderIntegrationHealthie.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/healthie`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderIntegrationHealthiePayloadToJSON(requestParameters['providerIntegrationHealthiePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationHealthieFromJSON(jsonValue));
    }

    /**
     * Update a Healthie integration details
     * Update a Healthie integration details
     */
    async updateProviderIntegrationHealthie(requestParameters: UpdateProviderIntegrationHealthieRequest): Promise<ProviderIntegrationHealthie> {
        const response = await this.updateProviderIntegrationHealthieRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a Healthie integration details
     * Update a Healthie integration details
     */
    async updateSupportIntegrationHealthieRaw(requestParameters: UpdateSupportIntegrationHealthieRequest): Promise<runtime.ApiResponse<SupportIntegrationHealthie>> {
        if (requestParameters['supportIntegrationHealthiePayload'] === null || requestParameters['supportIntegrationHealthiePayload'] === undefined) {
            throw new runtime.RequiredError('supportIntegrationHealthiePayload','Required parameter requestParameters.supportIntegrationHealthiePayload was null or undefined when calling updateSupportIntegrationHealthie.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/healthie`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIntegrationHealthiePayloadToJSON(requestParameters['supportIntegrationHealthiePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationHealthieFromJSON(jsonValue));
    }

    /**
     * Update a Healthie integration details
     * Update a Healthie integration details
     */
    async updateSupportIntegrationHealthie(requestParameters: UpdateSupportIntegrationHealthieRequest): Promise<SupportIntegrationHealthie> {
        const response = await this.updateSupportIntegrationHealthieRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a Nethealth integration details
     * Update a Nethealth integration details
     */
    async updateSupportIntegrationNethealthRaw(requestParameters: UpdateSupportIntegrationNethealthRequest): Promise<runtime.ApiResponse<SupportIntegrationNetHealth>> {
        if (requestParameters['supportIntegrationNetHealthPayload'] === null || requestParameters['supportIntegrationNetHealthPayload'] === undefined) {
            throw new runtime.RequiredError('supportIntegrationNetHealthPayload','Required parameter requestParameters.supportIntegrationNetHealthPayload was null or undefined when calling updateSupportIntegrationNethealth.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/nethealth`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIntegrationNetHealthPayloadToJSON(requestParameters['supportIntegrationNetHealthPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationNetHealthFromJSON(jsonValue));
    }

    /**
     * Update a Nethealth integration details
     * Update a Nethealth integration details
     */
    async updateSupportIntegrationNethealth(requestParameters: UpdateSupportIntegrationNethealthRequest): Promise<SupportIntegrationNetHealth> {
        const response = await this.updateSupportIntegrationNethealthRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a Royal integration details
     * Update a Royal integration details
     */
    async updateSupportIntegrationRoyalRaw(requestParameters: UpdateSupportIntegrationRoyalRequest): Promise<runtime.ApiResponse<SupportIntegrationRoyal>> {
        if (requestParameters['supportIntegrationRoyalPayload'] === null || requestParameters['supportIntegrationRoyalPayload'] === undefined) {
            throw new runtime.RequiredError('supportIntegrationRoyalPayload','Required parameter requestParameters.supportIntegrationRoyalPayload was null or undefined when calling updateSupportIntegrationRoyal.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/royal`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportIntegrationRoyalPayloadToJSON(requestParameters['supportIntegrationRoyalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationRoyalFromJSON(jsonValue));
    }

    /**
     * Update a Royal integration details
     * Update a Royal integration details
     */
    async updateSupportIntegrationRoyal(requestParameters: UpdateSupportIntegrationRoyalRequest): Promise<SupportIntegrationRoyal> {
        const response = await this.updateSupportIntegrationRoyalRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a Tebra integration
     * Update a tebra integration
     */
    async updateTebraIntegrationForBankUserRaw(requestParameters: UpdateTebraIntegrationForBankUserRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTebraIntegrationForBankUser.');
        }

        if (requestParameters['tebraIntegrationUpdateRequest'] === null || requestParameters['tebraIntegrationUpdateRequest'] === undefined) {
            throw new runtime.RequiredError('tebraIntegrationUpdateRequest','Required parameter requestParameters.tebraIntegrationUpdateRequest was null or undefined when calling updateTebraIntegrationForBankUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/tebra/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TebraIntegrationUpdateRequestToJSON(requestParameters['tebraIntegrationUpdateRequest']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a Tebra integration
     * Update a tebra integration
     */
    async updateTebraIntegrationForBankUser(requestParameters: UpdateTebraIntegrationForBankUserRequest): Promise<string> {
        const response = await this.updateTebraIntegrationForBankUserRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderApiIntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderApplicationSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderHl7IntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderIntegrationExportSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderIntegrationImportSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderTerminalIntegrationTokensOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderTerminalIntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportApiIntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportApplicationSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportHl7IntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportIntegrationExportSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportIntegrationImportSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
